import { useState, useRef } from "react";
import { debounce } from "lodash";
import toast from "react-hot-toast";
import useGet from "../read/useGet";
import usePut from "../put/usePut";

export const usePettyCashEntities = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedEntityId, setSelectedEntityId] = useState(null);

  const initialFilters = {
    limit: 10,
    page_number: 0,
    search_query: "",
  };

  const {
    list: entityList,
    paramsObject: filters,
    setGetListParams: setFilters,
  } = useGet({
    url: "petty-cash/entity_list",
    initialData: initialFilters,
  });

  const filtersRef = useRef(filters);
  filtersRef.current = filters;

  const debouncedSearch = useRef(
    debounce((value) => {
      const updated = { ...filtersRef.current, search_query: value, page_number: 0 };
      setFilters(updated);
    }, 300)
  ).current;

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    debouncedSearch(value);
  };

  const handlePageClick = (val) => {
    const updated = { ...filters, page_number: val.selected };
    setFilters(updated);
  };

  const { handleAuth: createEntityMutation } = usePut({
    url: "petty-cash/create_entity",
    refreshUrl: ["petty-cash/entity_list"],
    onSuccess: () => {
      toast.success("Entity created successfully");
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Failed to create entity");
    },
  });
  const { mutate: createEntity, isLoading: isCreating } = createEntityMutation;

  const { handleAuth: updateEntityMutation } = usePut({
    url: "petty-cash/update_entity",
    refreshUrl: ["petty-cash/entity_list"],
    onSuccess: () => {
      toast.success("Entity updated successfully");
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Failed to update entity");
    },
  });
  const { mutate: updateEntity, isLoading: isUpdating } = updateEntityMutation;

  const { handleAuth: deleteEntityMutation } = usePut({
    url: "petty-cash/delete_entity",
    refreshUrl: ["petty-cash/entity_list"],
    onSuccess: () => {
      toast.success("Entity deleted successfully");
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Failed to delete entity");
    },
  });
  const { mutate: deleteEntity, isLoading: isDeleting } = deleteEntityMutation;

  const {
    list: singleEntity,
    setGetListParams: setViewEntityParams,
  } = useGet({
    url: "petty-cash/view_entity",
    initialData: { entity_id: selectedEntityId },
    enabled: !!selectedEntityId,
  });

  const handleViewDetails = (entityId) => {
    setSelectedEntityId(entityId);
    setViewEntityParams({ entity_id: entityId });
  };

  return {
    entityList,
    filters,
    searchQuery,
    isCreating,
    isUpdating,
    isDeleting,
    singleEntity,
    selectedEntityId,
    setSelectedEntityId,
    handleSearchChange,
    handlePageClick,
    handleViewDetails,
    createEntity,
    updateEntity,
    deleteEntity,
  };
};
